// Safety for partnerize refs
const encodeUrl = (url) => url.replace(/ref:/gi, 'ref%3A');

export default function constructDealLink({ url, userId, anonymous }) {
  // Hydrate handlebars with the userId
  let link = !url.includes('{userId}')
    ? url
    : url.replace(
        '{userId}',
        `user_${anonymous || !userId ? 'anonymous' : userId}`,
      );

  // Check for protocol and add if needed
  if (!link.includes('https://') && !link.includes('http://')) {
    link = `http://${link}`;
  }

  return encodeUrl(link);
}
